import React from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
import { CheckCircleOutlined } from '@ant-design/icons';

const BookingSuccess = () => {
  const navigate = useNavigate();

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
      <Result
        icon={<CheckCircleOutlined style={{ color: '#52c41a', fontSize: 64 }} />}
        title="Booking Successful!"
        subTitle="Thank you for your payment. Your booking has been confirmed."
        extra={[
          <Button type="primary" size="large" key="home" onClick={() => navigate('/home')}>
            Book Another Car
          </Button>,
        ]}
        style={{
          background: '#fff',
          padding: '40px',
          borderRadius: '12px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        }}
      />
    </div>
  );
};

export default BookingSuccess;
